import { FC } from 'react';

import { Dropdown, Space } from 'antd';

import { DownOutlined, LogoutOutlined } from '@ant-design/icons';

import { useIntl, useModel, useNavigate, useRequest } from '@umijs/max';

import { useResponsive } from 'ahooks';

import { logout } from '@/services';

const UserDropdown: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const responsive = useResponsive();
  const { initialState } = useModel('@@initialState');

  const { run } = useRequest(logout, {
    manual: true,
    onSuccess: () => {
      localStorage.removeItem('userId');
      navigate('/login');
    },
  });

  return (
    <Dropdown menu={{
      items: [
        {
          icon: <LogoutOutlined />,
          key: 'logout',
          label: intl.formatMessage({ id: 'common.logout' }),
          onClick: () => { void run(); },
        },
      ],
    }}
    >
      <Space className="user-dropdown">
        { responsive.sm ? `${initialState?.currentUser?.firstName} ${initialState?.currentUser?.lastName}` : initialState?.currentUser?.firstName}
        <DownOutlined />
      </Space>
    </Dropdown>
  );
};

export default UserDropdown;
